import { ADD_MEDICAL_RECORD, FETCH_MEDICAL_RECORDS, FETCH_BREEDERS_DELIVERY, FETCH_DELETED_MEDICAL_RECORDS, FETCH_LEFT_MEDICAL_RECORDS, DELETE_MEDICAL_RECORDS, SHOW_MEDICAL_RECORD, ADD_AVATAR, ADD_MEDICATION, DELETE_MEDICATION, UPDATE_MEDICAL_RECORD, ATTACH_MR_AVATAR,GET_TOTAL_MR_COUNT, UPDATE_PRINT_MRECORD, CREATE_WOO_PET, PDF_GENERATOR_STATUS_CHANGE, RECOVER_MEDICL_RECORDS, FETCH_CONTRACT_FROM_WOO_STORE, UPDATE_WOO_PAGE_STATUS, FIND_PET_BYID, FETCH_BREEDERS_DELIVERY_BY_BREEDER_ID, BOOST_WOO_STORE_PROFILE, DELETE_PUPPY_VIDEO, UPDATE_VIDEO_CALL_STATUS, UPDATE_PIN_TO_TOP_QUEUE,DELETE_PROFILE_IMAGE,GET_LEADS_AVAILABLE_PETS,GET_AVAILABLE_PUPPIES_FROM_QUEUE,
  FETCH_AVAILABLE_PUPPIES_TO_QUEUE, GET_PET_NAMES_FROM_OPENAI, GET_PET_PERSONALITY_DESCRIPTION_FROM_OPENAI,UPDATE_MEDICAL_RECORD_MULTIPLE_IDS, UPDATE_MULTIPLE_MEDICAL_RECORDS_CALL_STATUS, FETCH_MEDICAL_RECORDS_BY_AGE, GET_PET_ZODIAC_PERSONALITY_DESCRIPTION_FROM_OPENAI } from '../actions';

  const initialState = {
  selectedToDelete: null,
  mRecord: '',
  mRecords: [],
  dMRecords: [],
  breedersDeliveryRecords: [],
  breedersDeliveryRecordsByBreederId: [],
  mLeftRecords: [],
  loading: false,
  showRecord: '',
  avtr: '',
  newMedication: '',
  deletedMedi: null,
  updatedMRecord: '',
  newAvatar: '',
  totalMRecords:0,
  mRecordsError:null,
  breedersDeliveryRecordError:null,
  dMRecordsError:null,
  mLeftRecordsError:null,
  mRecordError:null,
  selectedToDeleteError:null,
  showRecordError:null,
  avtrError:null,
  newMedicationError:null,
  deletedMediError:null,
  updatedMRecordError:null,
  newAvatarError:null,
  totalMRecordsError:null,
  authFailed:false,
  printMRecord: '',
  printMRecordError: null,
  wooPet: null,
  wooPetError: null,
  pdfStatus: false,
  recoveredMRecord: {},
  recoveredMRecordError: null,
  fetchContractStatus: null,
  fetchContractStatusError: null,
  updateWooPageStatus: null,
  updateWooPageStatusError: null,
  existingPet:false,
  boostWooProfile: '',
  boostWooProfileError: null,
  deletePuppyVideo: '',
  deletePuppyVideoError: null,
  videoCallStatus: "",
  videoCallStatusError: null,
  pinToTopQueue: {},
  updatedProfileImages : {},
  shuffleAvailablePuppiesFromQueue : {},
  suggestedPetPersonalityDescription : '',
};

// Reducer
function MRecordsReducer(state = initialState, action) {
  let mRecords,
    mRecord,
    mLeftRecords,
    selectedToDelete,
    showRecord,
    avtr,
    newMedication,
    deletedMedi,
    updatedMRecord,
    newAvatar,
    totalMRecords,
    authFailed,
    printMRecord,
    wooPet,
    recoveredMRecord,
    dMRecords,
    breedersDeliveryRecords,
    breedersDeliveryRecordsByBreederId,
    fetchContractStatus,
    updateWooPageStatus,
    existingPet,
    boostWooProfile,
    deletePuppyVideo,
    videoCallStatus,
    pinToTopQueue,
    updatedProfileImages,
    leadsAvailablePets,
    shuffleAvailablePuppiesFromQueue,
    fetchedAvailablePuppies,
    suggestedPetsNames,
    suggestedPetPersonalityDescription,
    suggestedPetZodiacDescription,
    updatedMultipleRecords,
    updatedCallStatusRecords,
    medicalRecordListFilteredByAge;

  switch (action.type) {
    case `${FETCH_MEDICAL_RECORDS}_PENDING`:
    case `${FETCH_DELETED_MEDICAL_RECORDS}_PENDING`:
    case `${FETCH_LEFT_MEDICAL_RECORDS}_PENDING`:
    case `${RECOVER_MEDICL_RECORDS}_PENDING`:  
    case `${ADD_MEDICAL_RECORD}_PENDING`:
    case `${DELETE_MEDICAL_RECORDS}_PENDING`:
    case `${SHOW_MEDICAL_RECORD}_PENDING`:
    case `${ADD_AVATAR}_PENDING`:
    case `${ADD_MEDICATION}_PENDING`:
    case `${DELETE_MEDICATION}_PENDING`:
    case `${UPDATE_MEDICAL_RECORD}_PENDING`:
    case `${ATTACH_MR_AVATAR}_PENDING`:
    case `${GET_TOTAL_MR_COUNT}_PENDING`:
    case `${UPDATE_PRINT_MRECORD}_PENDING`:
    case `${CREATE_WOO_PET}_PENDING`:
    case `${FETCH_BREEDERS_DELIVERY}_PENDING`:
    case `${FETCH_BREEDERS_DELIVERY_BY_BREEDER_ID}_PENDING`:
    case `${FETCH_CONTRACT_FROM_WOO_STORE}_PENDING`:  
    case `${UPDATE_WOO_PAGE_STATUS}_PENDING`:  
    case `${BOOST_WOO_STORE_PROFILE}_PENDING`: 
    case `${DELETE_PUPPY_VIDEO}_PENDING`:  
    case `${UPDATE_VIDEO_CALL_STATUS}_PENDING`: 
    case `${UPDATE_PIN_TO_TOP_QUEUE}_PENDING`:  
    case `${DELETE_PROFILE_IMAGE}_PENDING`:  
    case `${GET_LEADS_AVAILABLE_PETS}_PENDING`:
    case `${GET_AVAILABLE_PUPPIES_FROM_QUEUE}_PENDING`: 
    case `${FETCH_AVAILABLE_PUPPIES_TO_QUEUE}_PENDING`:  
    case `${GET_PET_NAMES_FROM_OPENAI}_PENDING`:      
    case `${ UPDATE_MEDICAL_RECORD_MULTIPLE_IDS}_PENDING`:   
    case `${UPDATE_MULTIPLE_MEDICAL_RECORDS_CALL_STATUS}_PENDING`:   
    case `${FETCH_MEDICAL_RECORDS_BY_AGE}_PENDING`: 
    case `${GET_PET_ZODIAC_PERSONALITY_DESCRIPTION_FROM_OPENAI}_PENDING`:   
    return { ...state, loading: true,
        mRecordsError:null,
        mLeftRecordsError:null,
        mRecordError:null,
        selectedToDeleteError:null,
        showRecordError:null,
        avtrError:null,
        newMedicationError:null,
        deletedMediError:null,
        updatedMRecordError:null,
        newAvatarError:null,
        totalMRecordsError:null,
        printMRecordError: null,
        wooPetError: null,
        dMRecordsError: null,
        recoveredMRecordError: null,
        breedersDeliveryRecordError: null,
        breedersDeliveryRecordsByBreederIdError: null,
        fetchContractStatusError: null,
        updateWooPageStatusError: null,

        fetchContractStatus: null,
        updateWooPageStatus: null,      
        existingPet: null,
        boostWooProfileError: null,
        deletePuppyVideoError: null,
        videoCallStatusError: null,
        fetchedAvailablePuppies:null,
        shuffleAvailablePuppiesFromQueue : {},
        suggestedPetsNames:null,
        updatedMultipleRecords:null,
        suggestedPetZodiacDescription:null,
      };
    
    case PDF_GENERATOR_STATUS_CHANGE:
      return {...state, loading: false, pdfStatus: action.payload, state: initialState };
      
    case `${FETCH_MEDICAL_RECORDS}_FULFILLED`:
      mRecords = action.payload.data;
      return {
        ...state, loading: false, mRecords,
      };

    case `${FETCH_DELETED_MEDICAL_RECORDS}_FULFILLED`:
      dMRecords = action.payload.data;  
      return {
        ...state, loading: false, dMRecords,
      }; 

    case `${FETCH_BREEDERS_DELIVERY}_FULFILLED`:
      breedersDeliveryRecords = action.payload.data;  
      return {
        ...state, loading: false, breedersDeliveryRecords,
      }; 

    case `${FETCH_BREEDERS_DELIVERY_BY_BREEDER_ID}_FULFILLED`:
      breedersDeliveryRecordsByBreederId = action.payload.data;  
      return {
        ...state, loading: false, breedersDeliveryRecordsByBreederId,
      }; 
      
    case `${FETCH_LEFT_MEDICAL_RECORDS}_FULFILLED`:
      mLeftRecords = action.payload.data;
      return {
        ...state, loading: false, mLeftRecords,
      };

    case `${ADD_MEDICAL_RECORD}_FULFILLED`:
      mRecord = action.payload.data;
      return { ...state, loading: false, mRecord };

    case `${DELETE_MEDICAL_RECORDS}_FULFILLED`:
      selectedToDelete = action.payload.data;
      return { ...state, loading: false, selectedToDelete };
    
    case `${SHOW_MEDICAL_RECORD}_FULFILLED`:
      showRecord = action.payload.data;
      return { ...state, loading: false, showRecord };

    case `${ADD_AVATAR}_FULFILLED`:
      avtr = action.payload.data;
      return { ...state, loading: false, avtr };

    case `${ADD_MEDICATION}_FULFILLED`:
      newMedication = action.payload.data;
      return { ...state, loading: false, newMedication };

    case `${DELETE_MEDICATION}_FULFILLED`:
      deletedMedi = action.payload.data;
      return { ...state, loading: false, deletedMedi };

    case `${UPDATE_MEDICAL_RECORD}_FULFILLED`:
      updatedMRecord = action.payload.data;
      return { ...state, loading: false, updatedMRecord };

    case `${RECOVER_MEDICL_RECORDS}_FULFILLED`:
      recoveredMRecord = action.payload.data;
      return { ...state, loading: false, recoveredMRecord };
      

    case `${ATTACH_MR_AVATAR}_FULFILLED`:
      newAvatar = action.payload.data;
      return { ...state, loading: false, newAvatar };

    case `${GET_TOTAL_MR_COUNT}_FULFILLED`:
      totalMRecords = action.payload.data;
      return {
        ...state, loading: false, totalMRecords,
      };
    
    case `${UPDATE_PRINT_MRECORD}_FULFILLED`:
      printMRecord = action.payload.data;
      return { ...state, loading: false, printMRecord };

    case `${CREATE_WOO_PET}_FULFILLED`:
      wooPet = action.payload.data;
      return { ...state, loading: false, wooPet };

    case `${FETCH_CONTRACT_FROM_WOO_STORE}_FULFILLED`:
      fetchContractStatus = action.payload.data;
      return { ...state, loading: false, fetchContractStatus };

    case `${UPDATE_WOO_PAGE_STATUS}_FULFILLED`:
      updateWooPageStatus = action.payload.data;
      return { ...state, loading: false, updateWooPageStatus };

    case `${BOOST_WOO_STORE_PROFILE}_FULFILLED`:
      boostWooProfile = action.payload.data;
      return { ...state, loading: false, boostWooProfile };

    case `${DELETE_PUPPY_VIDEO}_FULFILLED`:
      deletePuppyVideo = action.payload.data;
      return { ...state, loading: false, deletePuppyVideo };

    case `${UPDATE_VIDEO_CALL_STATUS}_FULFILLED`:
      videoCallStatus = action.payload.data;
      return { ...state, loading: false, videoCallStatus }; 

    case `${UPDATE_PIN_TO_TOP_QUEUE}_FULFILLED`:
      pinToTopQueue = action.payload.data;  
      return { ...state, loading: false, pinToTopQueue }; 

    case `${DELETE_PROFILE_IMAGE}_FULFILLED`:
      updatedProfileImages = action.payload.data;
      return { ...state, loading: false, updatedProfileImages };

    case `${GET_LEADS_AVAILABLE_PETS}_FULFILLED`:
        leadsAvailablePets = action.payload.data;
        return { ...state, loading: false, leadsAvailablePets };
        
    case `${GET_PET_NAMES_FROM_OPENAI}_FULFILLED`:
      suggestedPetsNames = action.payload.data;     
      return { ...state, loading: false, suggestedPetsNames };
              
    case `${GET_PET_PERSONALITY_DESCRIPTION_FROM_OPENAI}_FULFILLED`:
      suggestedPetPersonalityDescription = action.payload.data;     
      return { ...state, loading: false, suggestedPetPersonalityDescription };    
        return { ...state, loading: false, leadsAvailablePets };  

    case `${UPDATE_MEDICAL_RECORD_MULTIPLE_IDS}_FULFILLED`:
        updatedMultipleRecords = action.payload.data;
        return { ...state, loading: false, updatedMultipleRecords };  

    case `${GET_AVAILABLE_PUPPIES_FROM_QUEUE}_FULFILLED`:
      shuffleAvailablePuppiesFromQueue = action.payload.data; 
      return { ...state, loading: false, shuffleAvailablePuppiesFromQueue }; 

    case `${FETCH_AVAILABLE_PUPPIES_TO_QUEUE}_FULFILLED`:
      fetchedAvailablePuppies = action.payload.data;   
      return { ...state, loading: false, fetchedAvailablePuppies };  

    case `${UPDATE_MULTIPLE_MEDICAL_RECORDS_CALL_STATUS}_FULFILLED`:
      updatedCallStatusRecords = action.payload.data;   
      return { ...state, loading: false, updatedCallStatusRecords };  

    case `${UPDATE_MULTIPLE_MEDICAL_RECORDS_CALL_STATUS}_FULFILLED`:
      updatedCallStatusRecords = action.payload.data;   
      return { ...state, loading: false, updatedCallStatusRecords };  

    case `${FETCH_MEDICAL_RECORDS_BY_AGE}_FULFILLED`:
      medicalRecordListFilteredByAge = action.payload.data;   
      return { ...state, loading: false, medicalRecordListFilteredByAge };

    case `${GET_PET_ZODIAC_PERSONALITY_DESCRIPTION_FROM_OPENAI}_FULFILLED`:
      suggestedPetZodiacDescription = action.payload.data;   
      return { ...state, loading: false, suggestedPetZodiacDescription };      
  
    case `${FETCH_MEDICAL_RECORDS}_REJECTED`:
      return {...state, loading: false, mRecordsError: action.payload.response.data, state: initialState };
    case `${FETCH_LEFT_MEDICAL_RECORDS}_REJECTED`:
      return {...state, loading: false, dMRecordsError: action.payload.response.data, state: initialState };  
    case `${FETCH_LEFT_MEDICAL_RECORDS}_REJECTED`:
      return {...state, loading: false, mLeftRecordsError: action.payload.response.data, state: initialState };
    case `${ADD_MEDICAL_RECORD}_REJECTED`:
      return {...state, loading: false, mRecordError: action.payload.response.data, state: initialState };
    case `${DELETE_MEDICAL_RECORDS}_REJECTED`:
      return {...state, loading: false, selectedToDeleteError: action.payload.response.data, state: initialState };
    case `${SHOW_MEDICAL_RECORD}_REJECTED`:
      return {...state, loading: false, showRecordError: action.payload.response.data, state: initialState };
    case `${ADD_AVATAR}_REJECTED`:
      return {...state, loading: false, avtrError: action.payload.response.data, state: initialState };
    case `${ADD_MEDICATION}_REJECTED`:
      return {...state, loading: false, newMedicationError: action.payload.response.data, state: initialState };
    case `${DELETE_MEDICATION}_REJECTED`:
    return {...state, loading: false, deletedMediError: action.payload.response.data, state: initialState };
    case `${UPDATE_MEDICAL_RECORD}_REJECTED`:      
      return {...state, loading: false, updatedMRecordError: action.payload.response.data, state: initialState };
    case `${ATTACH_MR_AVATAR}_REJECTED`:
      return {...state, loading: false, newAvatarError: action.payload.response.data, state: initialState };
    case `${GET_TOTAL_MR_COUNT}_REJECTED`:
      return {...state, loading: false, totalMRecordsError: action.payload.response.data, state: initialState };
    case `${UPDATE_PRINT_MRECORD}_REJECTED`:
      return { ...state, loading: false, printMRecordError: action.payload.response.data, state: initialState };
    case `${CREATE_WOO_PET}_REJECTED`:
        return { ...state, loading: false, wooPetError: action.payload.response.data, state: initialState };
    case `${RECOVER_MEDICL_RECORDS}_REJECTED`:
      return { ...state, loading: false, recoveredMRecordError: action.payload.response.data, state: initialState };
    case `${FETCH_BREEDERS_DELIVERY}_REJECTED`:
        return { ...state, loading: false, breedersDeliveryRecordError: action.payload.response.data, state: initialState };
    case `${FETCH_BREEDERS_DELIVERY_BY_BREEDER_ID}_REJECTED`:
      return { ...state, loading: false, breedersDeliveryRecordsByBreederIdError: action.payload.response.data, state: initialState };
    case `${FETCH_CONTRACT_FROM_WOO_STORE}_REJECTED`:
      return { ...state, loading: false, fetchContractStatusError: action.payload.response.data, state: initialState };
    case `${UPDATE_WOO_PAGE_STATUS}_REJECTED`:
      return { ...state, loading: false, updateWooPageStatusError: action.payload.response.data, state: initialState };   
    case `${FIND_PET_BYID}_REJECTED`:   
      return { ...state, loadingAvailablePet: false, existingPetError: action.payload.response.data };
    case `${FIND_PET_BYID}_FULFILLED`:      
      existingPet = action.payload.data;
      return { ...state, loadingAvailablePet: false, existingPet };   
    case `${BOOST_WOO_STORE_PROFILE}_REJECTED`:
      return { ...state, loading: false, boostWooProfileError: action.payload.response.data, state: initialState };
    case `${DELETE_PUPPY_VIDEO}_REJECTED`:
      return { ...state, loading: false, deletePuppyVideoError: action.payload.response.data, state: initialState };
    case `${UPDATE_VIDEO_CALL_STATUS}_REJECTED`:   
      return { ...state, videoCallStatusError: action.payload.response.data };
    case `${UPDATE_PIN_TO_TOP_QUEUE}_REJECTED`:   
      return { ...state, pinToTopQueueError: action.payload.response.data };
    case `${ DELETE_PROFILE_IMAGE}_REJECTED`:   
      return { ...state, updatedProfileImagesError: action.payload.response.data };
    case `${GET_LEADS_AVAILABLE_PETS}_REJECTED`:   
      return { ...state, leadsAvailablePetsError: action.payload.response.data };
    case `${GET_AVAILABLE_PUPPIES_FROM_QUEUE}_REJECTED`:   
      return { ...state, shuffleAvailablePuppiesFromQueueError: action.payload.response.data }; 
    case `${FETCH_AVAILABLE_PUPPIES_TO_QUEUE}_REJECTED`:   
      return { ...state, fetchedAvailablePuppiesError: action.payload.response.data };    
    case `${GET_PET_NAMES_FROM_OPENAI}_REJECTED`:   
      return { ...state, suggestedPetsNamesError: action.payload.response.data };
    case `${GET_PET_PERSONALITY_DESCRIPTION_FROM_OPENAI}_REJECTED`:   
      return { ...state, suggestedPetPersonalityDescriptionError: action.payload.response.data };    
    case `${UPDATE_MEDICAL_RECORD_MULTIPLE_IDS}_REJECTED`:   
      return { ...state, updatedMultipleRecordsError: action.payload.response.data };   
    case `${UPDATE_MULTIPLE_MEDICAL_RECORDS_CALL_STATUS}_REJECTED`:   
      return { ...state, updatedCallStatusRecordsError: action.payload.response.data }; 
    case `${FETCH_MEDICAL_RECORDS_BY_AGE}_REJECTED`:
      return { ...state, medicalRecordListFilteredByAgeError: action.payload.response.data };    
    case `${GET_PET_ZODIAC_PERSONALITY_DESCRIPTION_FROM_OPENAI}_REJECTED`:
      return { ...state, suggestedPetZodiacDescriptionError: action.payload.response.data };       
    default:
      return state;
  }
}

export default MRecordsReducer;

